package com.crowpay

import com.crowpay.sdk.currentSession
import com.crowpay.sdk.sessionNotFound
import com.lightningkite.kiteui.reactive.PersistentProperty
import com.lightningkite.kiteui.reactive.ReactiveContext
import com.lightningkite.kiteui.reactive.lens
import com.lightningkite.kiteui.reactive.shared
import com.lightningkite.serialization.UUIDSerializer
import kotlinx.serialization.builtins.nullable
import kotlin.coroutines.cancellation.CancellationException

val selectedContractor = PersistentProperty("SelectedContractor", null, UUIDSerializer.nullable)

val currentContractor = shared {
    val session = currentSession() ?: return@shared null
    val selected = selectedContractor() ?: return@shared null
    session.contractors[selected]()
}
val contractorStatus = currentContractor.lens { it?.status }

val loggedInAsContractor = shared { selectedContractor() != null }

fun ReactiveContext.contractorInfoComplete(): Boolean = currentContractor()?.status != ContractorStatus.Registering

val notNullContractor = shared {
    selectedContractor() ?: run {
        sessionNotFound.invokeAll()
        throw CancellationException("Contractor not found")
    }
}